export default "__VITE_ASSET__LvPnMiVA__"